import i18n from 'i18next'
import { useTranslation, initReactI18next } from 'react-i18next'

import ZhCn from '@/assets/locales/zh-CN.json'
import enUS from '@/assets/locales/en-US.json'

const defaultLocale = 'zh-Hans'

export { useTranslation }

export enum LanguageEnum {
  EN_US = 'en-US',
  ZH_CN = 'zh-CN',
}

export const LanguageMap: { [key: string]: string } = {
  [LanguageEnum.EN_US]: 'English',
  [LanguageEnum.ZH_CN]: '简体中文',
}

export const LANGUAGE_KEY = 'Accept-Language'

const getLanguage = (): LanguageEnum => {
  const localLang = localStorage.getItem(LANGUAGE_KEY) as LanguageEnum
  if (Object.keys(LanguageMap).includes(localLang)) {
    return localLang
  }
  const browserLang = navigator.language.startsWith('zh') ? LanguageEnum.ZH_CN : LanguageEnum.EN_US
  return browserLang
}

export const locale = getLanguage()
const resources = {
  [LanguageEnum.EN_US]: { translation: { ...enUS } },
  [LanguageEnum.ZH_CN]: { translation: { ...ZhCn } },
}

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  resources,
  fallbackLng: defaultLocale,
  lng: locale,
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
})

export default i18n
